import styled from 'styled-components'
import BaseDatePicker from 'react-datepicker'

const DatePicker = styled(BaseDatePicker)`
  width: 120px;
  height: 30px;
  padding: 3px 0 0 10px;

  display: flex;
  align-items: center;

  color: #333333;
  font-family: 'Gotham';
  font-size: 14px;
  line-height: 15px;

  border-radius: 4px;
  border: 1px solid #e6e6e6;
`

export default DatePicker



// WEBPACK FOOTER //
// ./src/lib/components/DatePicker.jsx